export default __webpack_public_path__ + "static/media/badges.c88b40a4.svg";